import React from 'react';
import { Form } from 'formik';
import { MessagePropertiesContext } from '../../../../contexts/messageProperties';
import Input from '../../../../components/input';
import { ReserveCollectSearchResultStore } from '../../../../types';
import { SubmitButton } from '../../../global/header/search/components/input/input';

interface SearchFormProps {
  searchResults: ReserveCollectSearchResultStore[];
  handleSubmit: (e: React.SyntheticEvent<HTMLFormElement | HTMLButtonElement> | Event) => void;
  handleOnChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  serverError: string;
  isSearching: boolean;
  searchTerm: string;
}

function SearchForm({
  searchResults,
  handleSubmit,
  handleOnChange,
  serverError,
  isSearching,
  searchTerm
}: SearchFormProps): React.ReactElement {
  const [formattedMessage] = React.useContext(MessagePropertiesContext);

  return (
    <Form className={`reserve-collect__search ${searchResults.length > 0 ? 'hide' : ''}`} onSubmit={handleSubmit}>
      <Input
        type="search"
        name="reserveCollectSearch"
        autoComplete="on"
        label={formattedMessage({
          id: 'reserve.and.collect.placeholder',
          fallback: 'Enter your postcode or city'
        })}
        onChange={handleOnChange}
        className={serverError && 'reserve-collect__search-input-error'}
      />
      <div className="reserve-collect__submit-button-wrapper">
        {isSearching ? (
          <span className="loader" />
        ) : (
          <SubmitButton className="reserve-collect__submit-button" input={searchTerm} />
        )}
      </div>
      {serverError && <p className="reserve-collect__search-error">{serverError}</p>}
    </Form>
  );
}

export default SearchForm;
